export default {
  handleSuccessfulLogin({ commit }, payload) {
    localStorage.clear();
    const { user, token, quantumToken } = payload;

    commit("SAVE_USER_DETAILS", user);

    if (user.Org) {
      commit("SAVE_ORGANIZATION_DETAILS", user.Org);
      commit("SAVE_ORGANIZATION_ID", user.Org.id);
    }
    let usertype = ""
    if(user.onboardingtype == "3PL" && user.accounttype == "individual"){
      usertype = "solo_operator"
    }else if(user.onboardingtype == "3PL" && user.accounttype == "organization"){
      usertype = "enterprise_partner";
    }else if(user.onboardingtype == "ondemand" && user.accounttype == "individual"){
      usertype = "private_customer"
    }else if(user.onboardingtype == "ondemand" && user.accounttype == "organization"){
      usertype = "enterprise_customer"
    }else {
      usertype = "invalid_user"
    }

    commit("SET_TOKEN", token);
    commit("SET_QUANTUM_TOKEN", quantumToken);
    commit("SAVE_QUANTUM_USER_ID", user.quantumUserId);
    commit("SAVE_QUANTUM_ORGANIZATION_ID", user.quantumOrgId);
    commit("SAVE_USER_ID", user.id);
    commit("SAVE_USER_TYPE", usertype);
  },
  handleSuccessfulQuantumLogin({ commit }, payload) {
    const quantum = payload.data;
    commit("SET_QUANTUM_TOKEN", quantum.token);
    commit(
      "SAVE_QUANTUM_USER_ID",
      quantum.user.id || payload.data?.userId || ""
    );
    commit(
      "SAVE_QUANTUM_ORGANIZATION_ID",
      quantum.org.id || payload.data.orgId || ""
    );
  },
  saveUserDetails({ commit }, payload) {
    commit("SAVE_USER_DETAILS", payload);
  },
  saveAccountType({ commit }, payload){
    commit("SAVE_ACCOUNT_TYPE", payload)
  },
  saveGoogleApiKey({ commit }, payload){
    commit("SAVE_GOOGLE_KEY", payload)
  }
};
